document.addEventListener('DOMContentLoaded', () => {

  const slider = document.querySelector('.wg-products');

  if (!slider) return;

  const prevBtn = document.querySelector('.wg-products-prev');
  const nextBtn = document.querySelector('.wg-products-next');

  const card = () => slider.querySelector('.wg-product-card');

  const cardWidth = () => {
    if (!card()) return 300;
    const gap = 24;
    return card().offsetWidth + gap;
  };

  /*-----------------------------
  Arrow Navigation
  -----------------------------*/

  nextBtn?.addEventListener('click', () => {

    slider.scrollBy({
      left: cardWidth(),
      behavior: 'smooth'
    });

  });

  prevBtn?.addEventListener('click', () => {

    slider.scrollBy({
      left: -cardWidth(),
      behavior: 'smooth'
    });

  });

  /*-----------------------------
  Mouse Drag
  -----------------------------*/

  let isDown = false;
  let startX = 0;
  let scrollLeft = 0;

  slider.addEventListener('mousedown', e => {

    isDown = true;
    slider.classList.add('dragging');

    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;

  });

  window.addEventListener('mouseup', () => {

    isDown = false;
    slider.classList.remove('dragging');

  });

  slider.addEventListener('mousemove', e => {

    if (!isDown) return;

    e.preventDefault();

    const x = e.pageX - slider.offsetLeft;

    const walk = (x - startX) * 1.3;

    slider.scrollLeft = scrollLeft - walk;

  });

  /*-----------------------------
  Touch
  -----------------------------*/

  slider.style.scrollBehavior = "smooth";

});